module.exports = __webpack_public_path__ + "static/media/washingtonpost.com_news_morning-mix_wp_2016_10_11_five-dead-teens-a-stolen-cop-car-and-the-most-horrific-crash-in-decades__plot.adc7d9ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/washingtonpost.com_news_morning-mix_wp_2016_10_11_five-dead-teens-a-stolen-cop-car-and-the-most-horrific-crash-in-decades__plot.png
// module id = 432
// module chunks = 0